/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_PortalInputs */

const en_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Portal`)
};

const es_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal de administrador`)
};

const fr_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portail d'administration`)
};

const de_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Portal`)
};

const ja_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理ポータル`)
};

const zh_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理员门户`)
};

const ar_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوابة المسؤول`)
};

const id_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Admin`)
};

const it_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portale Amministratore`)
};

const ru_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Портал администратора`)
};

const pt_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal do Administrador`)
};

const ko_admin_portal = /** @type {(inputs: Admin_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관리자 포털`)
};

/**
* | output |
* | --- |
* | "Admin Portal" |
*
* @param {Admin_PortalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const admin_portal = /** @type {((inputs?: Admin_PortalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_PortalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_portal(inputs)
	if (locale === "es") return es_admin_portal(inputs)
	if (locale === "fr") return fr_admin_portal(inputs)
	if (locale === "de") return de_admin_portal(inputs)
	if (locale === "ja") return ja_admin_portal(inputs)
	if (locale === "zh") return zh_admin_portal(inputs)
	if (locale === "ar") return ar_admin_portal(inputs)
	if (locale === "id") return id_admin_portal(inputs)
	if (locale === "it") return it_admin_portal(inputs)
	if (locale === "ru") return ru_admin_portal(inputs)
	if (locale === "pt") return pt_admin_portal(inputs)
	return ko_admin_portal(inputs)
});